<template>
    <div
        class="bg-dark"
        :class="{
            'bg-dark--darken': [
                'panel-gate',
                'panel-competition-stoper',
				'panel-competition-scanner-qr'
            ].includes($route.name),
        }"
    >
        <div
            v-if="!isOnline"
            class="network-info"
        >
            <div class="row">
                <div class="col-12">
                    <p class="align-center">
                        Jesteś w trybie offline.
                    </p>
                </div>
            </div>
        </div>
        <div id="layoutBack">
            <base-notification-global />
            <layout-back-header
                v-if="!['panel-gate', 'panel-competition-scanner-qr'].includes($route.name)"
                :class="{
                    'd-none': isZenMode,
                    'none-mobile': $route.name === 'panel-competition-stoper' || $route.name === 'panel-competition-scanner-qr',
                }"
            />
            <div
                v-if="isMobile && (isStoper)"
                class="stoper-header"
            >
                <img
                    class="stoper-header__logo"
                    src="@/assets/images/logo-dostartu-white.svg"
                    alt="Logo dostartu"
                >
                <img
					v-show="isStoper"
                    src="@/assets/images/icons/home.svg"
                    alt="home logo"
                    class="stoper-header__menu"
                    @click="TOGGLE_NAV()"
                >
            </div>
            <panel-competition-nav-mobile v-if="isNavActive" />
            <router-view
                :class="{
                    relative: !$router.matched(
                        ['panel-competition-stoper', 'panel-competition-map', 'panel-competition-scanner-qr'],
                        $route,
                    ),
                }"
            />
        </div>

        <layout-back-footer
            v-if="!['panel-gate', 'panel-competition-scanner-qr'].includes($route.name)"
            class="panel-footer"
            :has-unseen="hasUnseenChangelog"
        />
        <changelog-latest-modal
            ref="changelogModal"
            :entry="latestChangelog"
        />
        <Communicator v-show="showCommunicator" />
    </div>
</template>

<script>
import LayoutBackHeader from '@/components/LayoutBackHeader';
import LayoutBackFooter from '@/components/LayoutBackFooter';
import Communicator from '@/components/Communicator';
import ChangelogLatestModal from '@/components/ChangelogLatestModal';
import { mapGetters, mapMutations } from 'vuex';
import PanelCompetitionNavMobile from '@/components/PanelCompetitionNavMobile';
import { TOGGLE_NAV } from '@/store/mutations.type';
import { listChangelog } from '@/api/changelog';
import {
    CHANGELOG_SEEN_EVENT,
    isUnseen,
    markSeen,
} from '@/utils/changelogStorage';

const CHANGELOG_MODAL_BLOCKED_ROUTES = [
    'panel-changelog',
    'panel-gate',
    'panel-competition-stoper',
    'panel-competition-map',
    'panel-competition-scanner-qr',
];

export default {
    components: {
        LayoutBackHeader,
        LayoutBackFooter,
        PanelCompetitionNavMobile,
        Communicator,
        ChangelogLatestModal,
    },
    data() {
        return {
            latestChangelog: null,
            hasUnseenChangelog: false,
        };
    },
    computed: {
        ...mapGetters(['isZenMode', 'isOnline', 'isNavActive']),
        isMobile() {
            return ['sm', 'md'].includes(this.$mq);
        },
        isStoper() {
            return this.$route.name === 'panel-competition-stoper';
        },
		isScannerQR() {
			return this.$route.name === 'panel-competition-scanner-qr';
		},
        showCommunicator() {
            if(this.isStoper && this.isMobile || this.isScannerQR && this.isMobile) {
                return false
            } 
            return true
        },
        canOpenChangelogModal() {
            return !CHANGELOG_MODAL_BLOCKED_ROUTES.includes(this.$route.name);
        },
    },
    watch: {
        '$route.name'(name) {
            if (name === 'panel-changelog' && this.latestChangelog) {
                markSeen(this.latestChangelog.id);
                this.closeChangelogModal();
            }
        },
    },
    created() {
        window.addEventListener(CHANGELOG_SEEN_EVENT, this.handleChangelogSeen);
    },
    async mounted() {
        await this.loadLatestChangelog();
    },
    beforeDestroy() {
        window.removeEventListener(CHANGELOG_SEEN_EVENT, this.handleChangelogSeen);
    },
    methods: {
        ...mapMutations([TOGGLE_NAV]),
        handleChangelogSeen() {
            this.hasUnseenChangelog = isUnseen(this.latestChangelog);
        },
        closeChangelogModal() {
            if (this.$refs.changelogModal) {
                this.$refs.changelogModal.close();
            }
        },
        async loadLatestChangelog() {
            try {
                const entries = await listChangelog(1);
                this.latestChangelog = Array.isArray(entries) && entries[0] ? entries[0] : null;

                if (!this.latestChangelog) {
                    this.hasUnseenChangelog = false;
                    return;
                }

                if (this.$route.name === 'panel-changelog') {
                    markSeen(this.latestChangelog.id);
                    this.hasUnseenChangelog = false;
                    return;
                }

                this.hasUnseenChangelog = isUnseen(this.latestChangelog);

                if (this.hasUnseenChangelog && this.canOpenChangelogModal) {
                    this.$nextTick(() => {
                        if (this.$refs.changelogModal) {
                            this.$refs.changelogModal.open();
                        }
                    });
                }
            } catch (error) {
                this.hasUnseenChangelog = false;
            }
        },
    },
};
</script>

<style scoped>
.bg-dark {
    background-color: var(--color-charcoal-grey);
    color: var(--color-white);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
.panel-footer {
    margin-top: auto;
}

.stoper-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--color-charcoal-grey);
    height: 64px;
    padding: 0 12px;
}
.stoper-header__menu {
    background-color: var(--color-slate-two);
    padding: 4px;
    border-radius: 50%;
    box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 992px) {
    .bg-dark {
        min-height: 100vh;
    }
    .bg-dark--darken {
        background-color: #263238;
    }
}
.relative {
    position: relative;
}

.pat1 {
    padding-top: 1px;
}

.d-none {
    display: none;
}
</style>
